// the password strentgth has been generated with ChatGPT using the general information from https://keepass.info/help/kb/pw_quality_est.html

// List of common passwords (for demo purposes, this is a small sample)
const commonPasswords = [
	"password",
	"123456",
	"123456789",
	"qwerty",
	"letmein",
	"welcome",
	"admin",
	"abc123",
	"aspazja",
	"dowodzenie",
	"zaq12wsx",
	"misiek",
	"1qaz2wsx",
	"zxcvbnm",
	"1qaz@WSX",
	"1qaz@WSX3edc",
	"6tfcvbnmjy",
	"asdfgh",
	"dupa",
	"abcdef",
];

// Function to check for common passwords and variations (e.g., l33t substitutions)
function isCommonPassword(password: string) {
	const l33tMapping: Record<string, string | undefined> = {
		a: "@",
		e: "3",
		i: "1",
		o: "0",
		s: "$",
		t: "7",
	};
	const lowerCasePassword = password.toLowerCase();

	// Check against common passwords
	if (commonPasswords.includes(lowerCasePassword)) {
		return true;
	}

	// Check for l33t variations
	const unleetPassword = lowerCasePassword.replace(/[aestio]/g, (char) => {
		return Object.keys(l33tMapping).find((key) => l33tMapping[key] === char) || char;
	});

	return (
		commonPasswords.includes(unleetPassword) ||
		commonPasswords.some(
			(commonPass) =>
				password.includes(commonPass) || unleetPassword.includes(commonPass)
		)
	);
}

// Function to check for repeated sequences
function hasRepeatedSequences(password: string) {
	return /(.)\1\1+/.test(password) || /(..+)\1+/.test(password);
}

// Function to check for number sequences (e.g., 1234 or 2468)
function isNumberSequence(password: string) {
	for (let i = 0; i < password.length - 1; i++) {
		const current = password[i];
		const next = password[i + 1];
		if (!current || !next) {
			continue;
		}
		if (isNaN(parseInt(current)) || isNaN(parseInt(next))) continue;
		const diff = parseInt(next) - parseInt(current);
		if (diff === 1 || diff === -1) return true;
	}
	return false;
}

// Function to check for constant difference sequences (e.g., abcd, bcde)
function hasConstantDifference(password: string) {
	for (let i = 0; i < password.length - 1; i++) {
		const diff = password.charCodeAt(i + 1) - password.charCodeAt(i);
		if (diff !== 1) {
			return false;
		}
	}
	return true;
}

// Function to calculate entropy based on character space
function calculateBaseEntropy(password: string) {
	let charSpace = 0;
	if (/[a-z]/.test(password)) charSpace += 26; // Lowercase letters
	if (/[A-Z]/.test(password)) charSpace += 26; // Uppercase letters
	if (/[0-9]/.test(password)) charSpace += 10; // Digits
	if (/[^a-zA-Z0-9]/.test(password)) charSpace += 32; // Symbols

	return password.length * Math.log2(charSpace);
}

// Main function to calculate password entropy
export function calculatePasswordEntropy(password: string) {
	let entropy = 0;

	// Step 1: Check for common password patterns
	if (isCommonPassword(password)) {
		return 0; // If it's a common password, entropy is 0
	}

	// Step 2: Base entropy calculation based on character space
	entropy += calculateBaseEntropy(password);

	// Step 3: Penalize for repeated sequences
	if (hasRepeatedSequences(password)) {
		entropy *= 0.4; // Reduce entropy for repeated sequences
	}

	// Step 4: Penalize for number sequences
	if (isNumberSequence(password)) {
		entropy *= 0.85; // Reduce entropy for number sequences
	}

	// Step 5: Penalize for constant difference sequences
	if (hasConstantDifference(password)) {
		entropy *= 0.8; // Reduce entropy for constant difference sequences
	}

	return entropy;
}
